export enum EDeviationState {
	Feedplan = 'feedplan',
	FeedplanWeight = 'feedplan_weight',
	Ration = 'ration',
	Camera = 'camera',
	CameraIssue = 'camera_issue',
}
